import type { FormikMedication } from 'src/app/state/actions/onBoardingActions';

const formatPhoneNumber = (phoneNumber: string) => phoneNumber.replace(/-/g, '');

const getControlMeds = (medications: FormikMedication[]) =>
  medications.filter(
    medication => medication.name && (medication.attributes?.controlSchedule ?? 'non-control') !== 'non-control'
  );

const setOnboardingStorage = (payload: { email?: string; phone?: string; zipCode: string; leadAccountId?: string }) =>
  window.localStorage.setItem('onboardingFlow', JSON.stringify(payload));

const getOnboardingStorage = () => {
  return JSON.parse(window.localStorage.getItem('onboardingFlow'));
};

const clearOnboardingStorage = () => window.localStorage.removeItem('onboardingFlow');

export { formatPhoneNumber, getControlMeds, setOnboardingStorage, getOnboardingStorage, clearOnboardingStorage };
